/* eslint-disable */
import { Route, Redirect } from 'react-router-dom'
import { useSession } from 'contexts/session-context'
import useRedirect from 'hooks/use-redirect'
import useLocalStorage from 'hooks/use-local-storage'
import { useAgegate } from 'hooks/use-agegate'
import useRouter from 'hooks/use-router'
import { useEffect } from 'react'
import { ScopeEnum } from 'routes/types'

const GuardedRoute = ({ ...rest }) => {
  const [{ user, survey }] = useSession()
  const [lState] = useLocalStorage('state', undefined)
  const { showAgegate, isMinor } = useAgegate()
  const [{ url }] = useRedirect();
  const {
    query,
    pathname
  }: {
    query: { referralCode?: string; utm_campaign?: string; utm_source?: string; utm_medium?: string, url_redirect?: string }
    pathname?: string
  } = useRouter()
  const [, setRefferal] = useLocalStorage('referralCode', query?.referralCode ?? '')
  const [, setUtm] = useLocalStorage(
    'utm',
    { utm_campaign: query?.utm_campaign, utm_source: query?.utm_source, utm_medium: query?.utm_medium } ?? ''
  )
  const encode = encodeURI(pathname)

  useEffect(() => {
    if (query?.referralCode) setRefferal(query?.referralCode)
    if (query?.utm_campaign || query?.utm_medium || query?.utm_source)
      setUtm({ utm_campaign: query?.utm_campaign, utm_source: query?.utm_source, utm_medium: query?.utm_medium })
  }, [query])

  let isLogged = user !== undefined;
  // ReCheck session in localstorage
  if (!isLogged) {
    isLogged = lState !== undefined && !!lState.user;
  }

  let urlParams = '';
  let paramArray = [];
  for (const key in query) {
    paramArray.push(`${key}=${query[key]}`)
  }

  if (paramArray) urlParams = `?${paramArray.join('&')}`

  if (!showAgegate && rest.path !== '/agegate' && !rest.notAgegate) return <Redirect to={`/agegate${urlParams}`} />

  if (showAgegate && isMinor && rest.path !== '/end') return <Redirect to="/end" />

  if (survey?.length > 0 && rest.path !== '/survey') return <Redirect to={`/survey?url=${encode}${urlParams}`} />

  if (isLogged && rest.scope === ScopeEnum.AUTH && rest.path !== '/home') {
    if (url && rest.scope !== ScopeEnum.AUTH) return <Redirect to={url} />
    return <Redirect to={`/home`} />
  }

  if (!isLogged && rest.scope === ScopeEnum.PRIVATE && rest.path !== '/start') return <Redirect to={`/start${urlParams}`} />

  return <Route {...rest} />
}

export default GuardedRoute;
